/**
 * Normalize saved table calibration to [{x,y}×4] in 0–1.
 * Accepts 4 points, 8 floats, JSON strings, and geometry objects.
 */
export function normalizeTableCorners(raw) {
  if (raw == null) return null;
  let value = raw;
  if (typeof value === "string") {
    try {
      value = JSON.parse(value);
    } catch {
      return null;
    }
  }
  if (value && typeof value === "object" && !Array.isArray(value)) {
    value =
      value.corners_norm ||
      value.corners ||
      value.table_corners ||
      value.tableCorners ||
      null;
    if (typeof value === "string") {
      try {
        value = JSON.parse(value);
      } catch {
        return null;
      }
    }
  }
  if (!Array.isArray(value) || !value.length) return null;

  let pts = [];
  if (
    value.length === 4 &&
    value[0] &&
    typeof value[0] === "object" &&
    !Array.isArray(value[0])
  ) {
    pts = value.map((c) => ({ x: Number(c.x), y: Number(c.y) }));
  } else if (value.length === 4 && Array.isArray(value[0])) {
    pts = value.map((c) => ({ x: Number(c[0]), y: Number(c[1]) }));
  } else if (value.length === 8) {
    for (let i = 0; i < 8; i += 2) {
      pts.push({ x: Number(value[i]), y: Number(value[i + 1]) });
    }
  }
  if (
    pts.length !== 4 ||
    pts.some((p) => !Number.isFinite(p.x) || !Number.isFinite(p.y))
  ) {
    return null;
  }
  return pts.map((p) => ({
    x: Math.min(1, Math.max(0, p.x)),
    y: Math.min(1, Math.max(0, p.y)),
  }));
}

export function pickTableCorners(...candidates) {
  for (const candidate of candidates) {
    const corners = normalizeTableCorners(candidate);
    if (corners) return corners;
  }
  return null;
}

/** True when both quads match within `eps` (normalized 0–1). Null vs quad is unequal. */
export function cornersEqual(a, b, eps = 0.002) {
  const left = normalizeTableCorners(a);
  const right = normalizeTableCorners(b);
  if (!left || !right) return left === right;
  for (let i = 0; i < 4; i += 1) {
    if (Math.abs(left[i].x - right[i].x) > eps) return false;
    if (Math.abs(left[i].y - right[i].y) > eps) return false;
  }
  return true;
}

export function cornersChanged(a, b, eps) {
  return !cornersEqual(a, b, eps);
}
